module.exports = __webpack_public_path__ + "static/media/smartphone.567a3f4b.svg";